import { ApolloError, makeVar } from '@apollo/client'

import { CustomerRole } from 'types/gql-global-types'
import { GetCustomerDetails_getCustomer as CustomerDetails } from 'types/gql-types/GetCustomerDetails'
import { ReceiptProps } from 'types/settings'
import { SiteCache, SiteTypeOperation, SiteWithType } from 'types/site'

export const rvSiteDetails = makeVar<SiteCache | null>(null)

export const rvSiteFetchError = makeVar<ApolloError | null>(null)

export const rvSettingsReceipt = makeVar({
  merchantCopy: false,
  printLogo: false,
  printSocials: false,
  logo: '',
  name: 'Zeller',
  message: 'Thank you for shopping at Zeller.',
  phone: '412345678',
  returnsMessage:
    "If you're not happy with your purchase, you can send item back to us FREE of charge within 100 days of the delivery date.",
  email: 'hello@myZeller.com',
  website: 'www.myzeller.com',
  instagram: 'myzeller',
  facebook: 'ZellerAustralia',
  twitter: 'ZellerAustralia',
} as ReceiptProps)

export const rvSelectedSite = makeVar('')

export const rvSelectedUser = makeVar('')

export const rvNewSites = makeVar([] as SiteCache[])

export const rvNewUserType = makeVar<CustomerRole | null>(null)

export const rvCustomerSiteOperation = makeVar<SiteTypeOperation | null>(null)

export const rvCurrentUserSites = makeVar<SiteCache[]>([])

export const rvUpdatedUserDetails = makeVar<Partial<CustomerDetails>>({})

export const rvSiteTypeList = makeVar<SiteWithType[]>([])
